var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardWidget',{staticClass:"widget-gauge",attrs:{"loading":_vm.loading,"title":_vm.title}},[_c('v-chart',{attrs:{"options":_vm.chart,"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }